import { Injectable } from '@angular/core';

/**
 * @deprecated This service and the firstLevel state should be removed
 * see for details https://wealthdynamixltd.atlassian.net/browse/CLMI-10296
 */
@Injectable()
export class FormFirstLevelService {
    firstLevel: { [key: string]: any } = {};
}
